import clsx from "clsx";
import React, { forwardRef } from "react";
import { FormattedMessage } from "react-intl";
import { svgIcon } from "../../utils/svgProvider";

interface EmailProps {
	id: string;
	label: string;
	value?: string;
	className?: string;
	placeholder?: string;
	tooltip?: string;
	readOnly?: boolean;
	disabled?: boolean;
	error?: string;
	maxLength?: number;
	optional?: string;
	autoComplete?: string;
	autoFocus?: boolean;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	loginLink?: React.ReactElement;
}

export const Email = forwardRef<HTMLInputElement, EmailProps>((props, ref) => {
	const {
		id,
		label,
		value,
		className,
		placeholder,
		tooltip,
		readOnly = false,
		disabled = false,
		error,
		maxLength,
		optional,
		autoComplete,
		autoFocus,
		onChange,
		onBlur,
		onKeyDown,
		loginLink,
	} = props;

	return (
		<div
			className={clsx({
				[`${className}`]: true,
				error: error,
				valid: value && !error,
			})}
		>
			<label className="label" htmlFor={id}>
				{label}
				{optional && <span className="optional">{optional}</span>}
				{!!tooltip && (
					<a className="hint--right hint--large" aria-label={tooltip}>
						{svgIcon.tooltip}
					</a>
				)}
			</label>
			<input
				ref={ref}
				onBlur={onBlur}
				onChange={onChange}
				onKeyDown={onKeyDown}
				className={clsx({ field: true, disabled: disabled })}
				id={id}
				placeholder={placeholder}
				readOnly={readOnly}
				disabled={disabled}
				type="email"
				maxLength={maxLength}
				autoComplete={autoComplete}
				aria-invalid={!!error}
				autoFocus={autoFocus}
				data-automationid={id}
				data-testid={`${id}.input`}
			/>

			{error && (
				<span
					className="errorMessage"
					data-automationid={`${id}.error`}
					data-testid={`${id}.error`}
				>
					<FormattedMessage
						id={error}
						values={{ fieldname: label, loginLink }}
					/>
				</span>
			)}
		</div>
	);
});
